import React from "react";
import {
  ImpersonationLogin,
} from "./actions";
import { useHistory, useParams } from "react-router";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

const ImpersonationUserLogin = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const {token}  = useParams();
  const onSuccess = () => {
    history.push({
      pathname: "/dashboard",
    });
  };

  useEffect(() => {
      dispatch(ImpersonationLogin(token, onSuccess))
  }, [])

  return (
  <p>Loading...</p>
  )
};

export default ImpersonationUserLogin;
